import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import cIf from 'classnames';

import { NumberSpinner } from '../../../../jsxctl/utilctl';
import TranslatorManager from 'ts-translate-js';

const tr = TranslatorManager.boundTR;

type QtySelectionProps = {
    eventDateIDs: number[];
    maxQty: number;
    limitQtySales: number;
    onFindTickets: Function;
    suggestedQtySales: number;
    internetTicketQTYMultipleOf: number;
    onContentChange?: Function;
    displayCancelButton?: boolean;
    onExpandQtyRequested?: () => void;
    onCancel?: () => void;
    errorMessage?: string;
}

export const QtySelection = createClass<QtySelectionProps>({
    displayName: "QtySelection",

    propTypes: {
        eventDateIDs: PropTypes.array.isRequired,
        maxQty: PropTypes.number.isRequired,
        limitQtySales: PropTypes.number.isRequired,
        onFindTickets: PropTypes.func.isRequired,
        suggestedQtySales: PropTypes.number,
        internetTicketQTYMultipleOf: PropTypes.number,
        onContentChange: PropTypes.func,
        displayCancelButton: PropTypes.bool,
        onExpandQtyRequested: PropTypes.func,
        onCancel: PropTypes.func,
        errorMessage: PropTypes.string,
    },

    getInitialState() {
        return { expandQty: false, numberoftickets: -1, qty: 0 };
    },

    componentDidMount() {

        const qtyMultipleOf = (this.props.internetTicketQTYMultipleOf > 0 ? this.props.internetTicketQTYMultipleOf : 1);

        const maxQty = this.props.maxQty * qtyMultipleOf;
        
        if(this.props.suggestedQtySales > maxQty)
            this.setState({ expandQty: true, qty: this.props.suggestedQtySales });
        
        if(this.props.onContentChange !== undefined) this.props.onContentChange();
    },

    componentDidUpdate() {
        if(this.props.onContentChange !== undefined) this.props.onContentChange();
    },

    handleSelectQty(maxQty, qtyMultipleOf) {
        this.setState({ expandQty: true, qty:maxQty + qtyMultipleOf });
        if (this.props.onExpandQtyRequested) {
            this.props.onExpandQtyRequested();
        }
    },

    handleFindTickets(e) {
        this.props.onFindTickets(e.target.value);
    },

    handleChangeQty(value){
        this.setState({qty:value});
    },

    handleOnSpinnerClick(){
        this.props.onFindTickets(this.state.qty);
    },

    render() {

        const qtyMultipleOf = (this.props.internetTicketQTYMultipleOf > 0 ? this.props.internetTicketQTYMultipleOf : 1);

        let maxQty = this.props.maxQty * qtyMultipleOf;

        if(this.props.limitQtySales > 0 && this.props.limitQtySales <= maxQty)
            maxQty = this.props.limitQtySales;

        // let limitMax = this.props.limitQtySales;
        // if(limitMax > 10 * qtyMultipleOf)
        //     limitMax = 10 * qtyMultipleOf; // quand la limite est vraiment exagérer on permet 10 à la fois

        const qtyctrls = [];

        if(this.state.expandQty) {
            qtyctrls.push(
                <div key="qtySelect">
                    <div className="row priceRow">
                        <div className="qty-selection">
                            <NumberSpinner className="input-group number-spinner" 
                                value={this.state.qty} 
                                min={qtyMultipleOf} 
                                qtyMultipleOf={qtyMultipleOf} 
                                max={this.props.limitQtySales} 
                                onChange={this.handleChangeQty} 
                                disabled={false}>
                            </NumberSpinner>
                        </div>
                    </div>
                </div>
            );
            if (this.props.errorMessage != null) {
                qtyctrls.push(<div key="error" className="alert alert-danger">{tr(this.props.errorMessage)}</div>);
            }
            qtyctrls.push(
                <div key="actions" className="h1 actions">
                    {this.props.displayCancelButton && <button className="input-group btn btn-default" onClick={this.props.onCancel}>{tr('Annuler')}</button>}
                    <button className="input-group btn btn-primary" onClick={this.handleOnSpinnerClick}>{tr('SUIVANT')}</button>
                </div>
            );
        }
        else {
            //TODO: Refactor this to avoid using a loop
            //eslint-disable-next-line no-loops/no-loops
            for(let i = qtyMultipleOf; i <= maxQty; i=i+qtyMultipleOf) {
                qtyctrls.push(<button key={"qtyBtn" + i} className={cIf({
                    qtybtn: true,
                    "icon-btn": true,
                    btn: true,
                    'btn-primary': true,
                    disabled: (this.props.eventDateIDs.count == 0)
                })} onClick={this.handleFindTickets} value={i}>{i}</button>); 
            }
        }

            
        // "+" button
        if(!this.state.expandQty && this.props.limitQtySales > maxQty) {
            qtyctrls.push(<button key="qtyBtn" className="qtybtn icon-btn btn btn-default" onClick={function() { this.handleSelectQty(maxQty, qtyMultipleOf); }.bind(this)}>+</button>);
            if (this.props.errorMessage != null) {
                qtyctrls.push(<div key="error" className="alert alert-danger">{tr(this.props.errorMessage)}</div>);
            }
            if (this.props.displayCancelButton)
                qtyctrls.push(
                    <div className="h1 actions">
                        <button className="center-block input-group btn btn-default" onClick={this.props.onCancel}>{tr('Annuler')}</button>
                    </div>
                );
        }
        
        
        return (<div>
            {qtyctrls}
        </div>);

    }
});

QtySelection.defaultProps = {
    displayCancelButton: false,
};
